import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";
import type { EarthquakeScaleOption } from "../../types/condition";

const earthquakeScale: EarthquakeScaleOption[] = [
  { scale: "0", name: "0" },
  { scale: "1", name: "1" },
  { scale: "2", name: "2" },
  { scale: "3", name: "3" },
  { scale: "4", name: "4" },
  { scale: "5-", name: "5弱" },
  { scale: "5+", name: "5強" },
  { scale: "6-", name: "6弱" },
  { scale: "6+", name: "6強" },
  { scale: "7", name: "7" },
];

type EarthquakeScaleProps = {
  changedValue: (scale: string | undefined) => void;
  inputValue?: string | null;
  disabled?: boolean;
};

const EarthquakeScaleSelect = ({
  changedValue,
  inputValue,
  disabled,
}: EarthquakeScaleProps) => {
  const [value, setValue] = useState<EarthquakeScaleOption | null>(null);

  useEffect(() => {
    if (inputValue) {
      const newValue = earthquakeScale.find(
        (scale) => scale.scale === inputValue
      );
      setValue(newValue ?? null);
    }
  }, [inputValue]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: EarthquakeScaleOption | null
  ) => {
    setValue(newValues);
    changedValue(newValues?.scale);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={earthquakeScale}
      getOptionLabel={(pref) => pref.name}
      isOptionEqualToValue={(option, value) => option.scale === value.scale}
      renderInput={(params) => (
        <TextField {...params} name="earthquakeScaleSelect" label="震度選択" />
      )}
      onChange={handleChange}
      value={value}
      disabled={disabled}
    />
  );
};

export default EarthquakeScaleSelect;
